import { Card } from "react-bootstrap";
import { Helmet } from "react-helmet";
import ResetPasswordForm from "./ResetPasswordForm";
import { ShieldCheckIcon } from "@heroicons/react/outline";

const ResetPassword = () => (
	<Card className="mx-auto">
		<Helmet>
			<title>
				{"Choose New Password"}
			</title>
		</Helmet>

		<Card.Body className="p-5 text-center">
			<div className="mt-4 mb-3">
				<ShieldCheckIcon className="i i-4x text-green" />
			</div>

			<h3 className="text-blue mb-5">
				Choose a New Password
			</h3>
			<ResetPasswordForm />
		</Card.Body>
	</Card>
);

export default ResetPassword;
